import React from 'react';
import { Box, StepGroup, StepItem } from '@razorpay/blade/components';
import { useWizardInfo } from 'components/WizardViews/providers/WizardInfoProvider';
import useIsFeatureDisabledForRearch from 'access/useIsFeatureDisabledForRearch';
import { getStepMarker } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/utils';
import { revisePaySteps } from '../constants';
import { renderMarker } from 'components/EmployeeOnboarding/EmployeeSelfOnboarding/viewHelpers';

const stepsWithMSS = [
  { id: 'update-ctc', title: 'Update CTC', step: revisePaySteps.step1 },
  { id: 'update-structure', title: 'Update structure', step: revisePaySteps.step2 },
  { id: 'preview', title: 'Preview', step: revisePaySteps.step3 },
];

const steps = [
  { id: 'update-ctc', title: 'Update CTC', step: revisePaySteps.step1 },
  { id: 'preview', title: 'Preview', step: revisePaySteps.step3 },
];

export const Sidebar = () => {
  const { currentStep } = useWizardInfo();
  const { isM3S1Enabled } = useIsFeatureDisabledForRearch();

  const stepsToRender = isM3S1Enabled ? stepsWithMSS : steps;

  return (
    <Box display="flex" flexDirection="column" height="100%" justifyContent="space-between">
      <StepGroup orientation="vertical" size="medium">
        {stepsToRender.map((stepData) => (
          <StepItem
            key={stepData.id}
            title={stepData.title}
            marker={renderMarker(getStepMarker(currentStep, stepData.step))}
            isSelected={stepData.step === currentStep}
            isDisabled={stepData.step > currentStep}
          />
        ))}
      </StepGroup>
    </Box>
  );
};
